import React, { useState, useEffect } from "react"
import { useShowLoggedInMenus } from "./../../services/authService"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { switchUserThunk, signOutThunk } from "./../../store/thunks/startupThunks"
import { Nav, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"
import "./SwitchUserMenu.scss"
import { IUserRelationFlattened } from "./../../type/IUserRelation"
import { userRelationSelectors } from "./../../store/reducers/userRelationReducer"
import { getIconClassForRelation, filterAndSortUserRelationsForSwitchUserMenu } from "../../services/userRelationService"
import { navigationService } from "./../../services/navigationService"
import cn from "classnames"
import useReduxDispatch from "../../store/useReduxDispatch"

interface ISwitchUserMenuProps {}

interface IOptionProps {
    iconClass: string
    text: string
    isLogout?: boolean
}
const Option = ({ iconClass, text, isLogout }: IOptionProps) => {
    return (
        <>
            <span className={`icon ${iconClass}`} />
            <span className={cn("account-name", "d-md-inline-block", { "font-weight-bold": isLogout })}>{text}</span>
        </>
    )
}

const SwitchUserMenu = ({}: ISwitchUserMenuProps) => {
    const showLoggedInMenus = useShowLoggedInMenus()

    const dispatch = useReduxDispatch()

    const currentUserRelation = useSelector(userRelationSelectors.currentUserRelation)
    const userRelationsFlattened = useSelector(userRelationSelectors.userRelationsFlattened) || []
    const lastVisitedAccounts = useSelector(userRelationSelectors.lastUsedRelations)

    const getUserRealtionsToShow = (): IUserRelationFlattened[] => {
        return filterAndSortUserRelationsForSwitchUserMenu(userRelationsFlattened, lastVisitedAccounts)
    }

    const userRelationsToShow = userRelationsFlattened.length > 5 ? getUserRealtionsToShow() : userRelationsFlattened
    const [isOpen, setIsOpen] = useState(false)
    const { t } = useTranslation()

    if (!currentUserRelation || !showLoggedInMenus) {
        return null
    }

    const getOption = (userRelation: IUserRelationFlattened) => {
        return <Option iconClass={getIconClassForRelation(userRelation)} text={userRelation.name || ""} />
    }

    const onUserRelationClick = (userRelation: IUserRelationFlattened) => {
        dispatch(switchUserThunk(userRelation))
    }

    const onLogoutClick = () => {
        dispatch(signOutThunk())
    }

    return (
        <Nav navbar>
            <Dropdown nav className="navbar-dropdown" isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
                <DropdownToggle nav caret>
                    {getOption(currentUserRelation)}
                </DropdownToggle>
                <DropdownMenu>
                    {userRelationsToShow.slice(0, 5).map((userRelation, index) => {
                        const optionComp = getOption(userRelation)
                        if (!optionComp || userRelation.id === currentUserRelation.id) {
                            return null
                        }
                        return (
                            <DropdownItem onClick={() => onUserRelationClick(userRelation)} key={index}>
                                {optionComp}
                            </DropdownItem>
                        )
                    })}
                    {userRelationsFlattened.length > 5 && (
                        <DropdownItem onClick={() => navigationService.navigate("manageuserrelations")}>
                            <Option iconClass="icon-roleswitch-seall" text={t("menu.showAll")} />
                        </DropdownItem>
                    )}
                    <DropdownItem onClick={() => onLogoutClick()}>
                        <Option iconClass="icon-nav-logout" isLogout text={t("menu.logout")} />
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </Nav>
    )
}

export default SwitchUserMenu
